var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { convertModelToFormData } from '../../common/helpers/form-helpers';
import { monteurApi } from '../common/monteur-api';
import { signalRService } from '../common/signalR-service';
export var machinesApi = monteurApi
    .enhanceEndpoints({
    addTagTypes: [
        'Machines',
        'Machine',
        'PaginatedMachines',
        'PaginatedMachineLibrary',
        'MachineModels',
        'MachineModel',
        'CompanyMachines',
        'MachinesWithDocuments',
        'ModelsWithDocuments',
        'Brands',
        'MachineAnalytics',
        'MachineModelsSerials',
        'MatchingMachines'
    ]
})
    .injectEndpoints({
    endpoints: function (builder) { return ({
        getMachinesList: builder.query({
            query: function (query) {
                return "Machine/get-all?filterByCompany=".concat(query.filterByCompany, "&isMachineLibrary=").concat(query.isMachineLibrary);
            },
            providesTags: ['Machines']
        }),
        getMatchingMachines: builder.query({
            query: function (query) { return ({
                url: "Machine/get-matching-machines",
                method: 'POST',
                body: query
            }); },
            providesTags: ['MatchingMachines']
        }),
        getActiveMachinesList: builder.query({
            query: function (query) {
                return "Machine/get-all-active?filterByCompany=".concat(query.filterByCompany, "&companyId=").concat(query.companyId);
            },
            providesTags: ['Machines']
        }),
        getActiveMachinesWithModels: builder.query({
            query: function (query) {
                return "Machine/get-all-active-with-models?filterByCompany=".concat(query.filterByCompany, "&companyId=").concat(query.companyId);
            },
            providesTags: ['Machines']
        }),
        getPaginatedMachines: builder.query({
            query: function (machine) { return ({
                url: "Machine/get-paginated",
                method: 'POST',
                body: machine
            }); },
            providesTags: ['PaginatedMachines'],
            onCacheEntryAdded: function (_1, _a) {
                return __awaiter(this, arguments, void 0, function (_, _b) {
                    var cacheDataLoaded = _b.cacheDataLoaded, cacheEntryRemoved = _b.cacheEntryRemoved, updateCachedData = _b.updateCachedData;
                    return __generator(this, function (_c) {
                        switch (_c.label) {
                            case 0: return [4 /*yield*/, cacheDataLoaded];
                            case 1:
                                _c.sent();
                                return [4 /*yield*/, signalRService.initializeConnection()];
                            case 2:
                                _c.sent();
                                signalRService.subscribeToEvent('ReceiveDocumentsCountNotification', function (items) {
                                    updateCachedData(function (currentData) {
                                        items.forEach(function (item) {
                                            var machine = currentData.items.find(function (machine) { return machine.id === item.machineId; });
                                            if (machine) {
                                                machine.processingDocuments =
                                                    item.processingDocuments + machine.processingDocuments;
                                                machine.processedDocuments =
                                                    item.processedDocuments + machine.processedDocuments;
                                                machine.unprocessableDocuments =
                                                    item.unprocessableDocuments + machine.unprocessableDocuments;
                                                machine.failedDocuments = item.failedDocuments + machine.failedDocuments;
                                            }
                                        });
                                    });
                                });
                                return [4 /*yield*/, cacheEntryRemoved];
                            case 3:
                                _c.sent();
                                signalRService.unsubscribeFromEvent('ReceiveDocumentsCountNotification');
                                return [2 /*return*/];
                        }
                    });
                });
            }
        }),
        getPaginatedMachineLibrary: builder.query({
            query: function (machine) { return ({
                url: "Machine/get-paginated-machine-library",
                method: 'POST',
                body: machine
            }); },
            providesTags: ['PaginatedMachineLibrary']
        }),
        getModels: builder.query({
            query: function (machineId) { return ({
                url: "Machine/get-models?machineId=".concat(machineId),
                method: 'GET'
            }); },
            providesTags: ['MachineModels']
        }),
        getModelsSerials: builder.query({
            query: function (machineId) { return ({
                url: "Machine/get-models-serials?machineId=".concat(machineId),
                method: 'GET'
            }); },
            providesTags: ['MachineModelsSerials']
        }),
        findMachine: builder.mutation({
            query: function (query) {
                if (query.id && query.modelNumber)
                    return {
                        url: "Machine/find?id=".concat(query.id, "&modelNumber=").concat(query.modelNumber),
                        method: 'GET'
                    };
                else if (query.id && !query.modelNumber)
                    return {
                        url: "Machine/find?id=".concat(query.id),
                        method: 'GET'
                    };
                else
                    return {
                        url: "Machine/find?serialNumber=".concat(query.serialNumber),
                        method: 'GET'
                    };
            }
        }),
        findMachineBySerialNumber: builder.query({
            query: function (serialNumber) { return "Machine/find-by-serial-no?serialNumber=".concat(serialNumber); },
            providesTags: ['MachineModel']
        }),
        getByGTIN: builder.query({
            query: function (query) { return "Machine/get-by-gtin?GTIN=".concat(query); }
        }),
        createMachine: builder.mutation({
            query: function (createMachine) { return ({
                url: 'Machine/create',
                method: 'POST',
                body: createMachine
            }); },
            invalidatesTags: [
                'MachineAnalytics',
                'Machines',
                'PaginatedMachines',
                'PaginatedMachineLibrary',
                'AllClients',
                'FolderView'
            ]
        }),
        linkToMachine: builder.mutation({
            query: function (LinkToMachineDto) { return ({
                url: 'Machine/link-to-machine',
                method: 'POST',
                body: LinkToMachineDto
            }); },
            invalidatesTags: [
                'MachineAnalytics',
                'Machines',
                'Machine',
                'PaginatedMachines',
                'PaginatedMachineLibrary',
                'CompanyMachines',
                'AllClients',
                'FolderView'
            ]
        }),
        createAndLinkMachine: builder.mutation({
            query: function (machineData) { return ({
                url: 'Machine/create-and-link',
                method: 'POST',
                body: convertModelToFormData(machineData)
            }); },
            invalidatesTags: [
                'MachineAnalytics',
                'Machines',
                'PaginatedMachines',
                'AllClients',
                'FolderView'
            ]
        }),
        updateMachine: builder.mutation({
            query: function (machine) { return ({
                url: 'Machine/update',
                method: 'POST',
                body: machine
            }); },
            invalidatesTags: [
                'MachineAnalytics',
                'Machines',
                'Machine',
                'PaginatedMachines',
                'PaginatedMachineLibrary',
                'AllClients',
                'CompanyMachines',
                'FolderView'
            ]
        }),
        getMachine: builder.query({
            query: function (id) { return ({
                url: "Machine/get-by-id?id=".concat(id)
            }); },
            providesTags: ['Machine']
        }),
        getMachineTechnicians: builder.query({
            query: function (machineId) { return ({
                url: "Machine/get-technicians?machineId=".concat(machineId),
                method: 'GET'
            }); },
            keepUnusedDataFor: 0
        }),
        getMachineClients: builder.query({
            query: function (machineId) { return ({
                url: "Machine/get-clients?machineId=".concat(machineId),
                method: 'GET'
            }); },
            keepUnusedDataFor: 0
        }),
        getMachineLibraryDetail: builder.query({
            query: function (machineId) { return ({
                url: "Machine/get-machine-library-detail?machineId=".concat(machineId),
                method: 'GET'
            }); },
            keepUnusedDataFor: 0
        }),
        addSerialNumber: builder.mutation({
            query: function (machine) { return ({
                url: 'Machine/add-serial-number',
                method: 'POST',
                body: machine
            }); },
            invalidatesTags: [
                'PaginatedMachines',
                'PaginatedMachineLibrary',
                'AllClients',
                'MachineModels',
                'MachineModelsSerials',
                'CompanyMachines',
                'MachineModel',
                'FolderView',
                'ModelFolder',
                'OtherFolder'
            ]
        }),
        deleteMachineModels: builder.mutation({
            query: function (models) { return ({
                url: 'Machine/delete-model-numbers',
                method: 'POST',
                body: models
            }); },
            invalidatesTags: [
                'MachineModels',
                'MachineModelsSerials',
                'MachinesWithDocuments',
                'ModelsWithDocuments',
                'MachineModel',
                'FolderView',
                'ModelFolder',
                'OtherFolder',
                'Machines'
            ]
        }),
        deleteSingleModel: builder.mutation({
            query: function (models) { return ({
                url: 'Machine/delete-single-model-number',
                method: 'POST',
                body: models
            }); },
            invalidatesTags: [
                'MachineModels',
                'MachineModelsSerials',
                'MachinesWithDocuments',
                'ModelsWithDocuments',
                'MachineModel',
                'FolderView',
                'ModelFolder',
                'OtherFolder',
                'Machines'
            ]
        }),
        updateSerialNumber: builder.mutation({
            query: function (machine) { return ({
                url: 'Machine/update-serial-number',
                method: 'POST',
                body: machine
            }); },
            invalidatesTags: [
                'Machines',
                'Machine',
                'PaginatedMachines',
                'PaginatedMachineLibrary',
                'AllClients',
                'MachineModels',
                'MachineModelsSerials',
                'MachineModel',
                'FolderView',
                'ModelFolder',
                'OtherFolder'
            ]
        }),
        getMachineModelsByClient: builder.query({
            query: function (machine) { return ({
                url: "Machine/get-by-client",
                method: 'POST',
                body: machine
            }); },
            providesTags: ['Machine']
        }),
        getAllByDocument: builder.query({
            query: function (Document) { return ({
                url: "Machine/get-all-by-document",
                method: 'POST',
                body: Document
            }); },
            providesTags: ['Machine']
        }),
        updateMachineStatus: builder.mutation({
            query: function (machine) { return ({
                url: 'Machine/update-status',
                method: 'POST',
                body: machine
            }); },
            invalidatesTags: [
                'Machines',
                'AllClients',
                'CompanyMachines',
                'PaginatedMachines',
                'PaginatedMachineLibrary',
                'MachinesWithDocuments',
                'ModelsWithDocuments',
                'FolderView'
            ]
        }),
        getAllMachinesByCompany: builder.query({
            query: function (query) { return ({
                url: "Machine/get-all-by-company?companyId=".concat(query.companyId, "&isMachineLibrary=").concat(query.isMachineLibrary),
                method: 'GET'
            }); },
            providesTags: ['CompanyMachines']
        }),
        getModelNumbersByMachines: builder.query({
            query: function (machines) { return ({
                url: "Machine/get-models-by-machines",
                method: 'POST',
                body: { machines: machines }
            }); }
        }),
        getModelsWithDocuments: builder.query({
            query: function (request) { return ({
                url: "Machine/get-models-with-documents",
                method: 'POST',
                body: request
            }); }
        }),
        getAllMachinesWithDocumentCount: builder.query({
            query: function () { return ({
                url: "Machine/get-all-with-documents",
                method: 'GET'
            }); },
            providesTags: ['MachinesWithDocuments']
        }),
        getModelsWithDocumentCount: builder.query({
            query: function (machineId) { return ({
                url: "Machine/get-all-models-with-documents?machineId=".concat(machineId),
                method: 'GET'
            }); },
            providesTags: ['ModelsWithDocuments']
        }),
        getMachineBrandList: builder.query({
            query: function (query) { return "Machine/get-all-brands?filterByCompany=".concat(query.filterByCompany); },
            providesTags: ['Machines', 'Brands']
        }),
        getMachineAnalytics: builder.query({
            query: function (query) { return ({
                url: "Machine/get-analytics",
                method: 'POST',
                body: query
            }); },
            keepUnusedDataFor: 0,
            providesTags: ['MachineAnalytics']
        }),
        getMachineClientsSerials: builder.query({
            query: function (query) { return ({
                url: "Machine/get-clients-serials",
                method: 'POST',
                body: query
            }); },
            keepUnusedDataFor: 0
        }),
        updateClientMachine: builder.mutation({
            query: function (machine) { return ({
                url: 'Machine/update-client-machine',
                method: 'POST',
                body: machine
            }); },
            invalidatesTags: [
                'Machines',
                'AllClients',
                'CompanyMachines',
                'PaginatedMachines',
                'PaginatedMachineLibrary',
                'MachinesWithDocuments',
                'ModelsWithDocuments',
                'FolderView',
                'MachineModelsSerials',
                'MachineModels',
                'ModelFolder',
                'OtherFolder'
            ]
        })
    }); }
});
export var useGetMachinesListQuery = machinesApi.useGetMachinesListQuery, useGetMachineBrandListQuery = machinesApi.useGetMachineBrandListQuery, useGetActiveMachinesListQuery = machinesApi.useGetActiveMachinesListQuery, useLazyGetMatchingMachinesQuery = machinesApi.useLazyGetMatchingMachinesQuery, useGetPaginatedMachinesQuery = machinesApi.useGetPaginatedMachinesQuery, useGetPaginatedMachineLibraryQuery = machinesApi.useGetPaginatedMachineLibraryQuery, useGetMachineLibraryDetailQuery = machinesApi.useGetMachineLibraryDetailQuery, useFindMachineMutation = machinesApi.useFindMachineMutation, useLazyGetModelsQuery = machinesApi.useLazyGetModelsQuery, useLazyFindMachineBySerialNumberQuery = machinesApi.useLazyFindMachineBySerialNumberQuery, useLazyGetMachineQuery = machinesApi.useLazyGetMachineQuery, useCreateAndLinkMachineMutation = machinesApi.useCreateAndLinkMachineMutation, useCreateMachineMutation = machinesApi.useCreateMachineMutation, useLinkToMachineMutation = machinesApi.useLinkToMachineMutation, useUpdateMachineMutation = machinesApi.useUpdateMachineMutation, useGetMachineClientsQuery = machinesApi.useGetMachineClientsQuery, useLazyGetMachineClientsQuery = machinesApi.useLazyGetMachineClientsQuery, useGetMachineTechniciansQuery = machinesApi.useGetMachineTechniciansQuery, useLazyGetMachineTechniciansQuery = machinesApi.useLazyGetMachineTechniciansQuery, useAddSerialNumberMutation = machinesApi.useAddSerialNumberMutation, useDeleteMachineModelsMutation = machinesApi.useDeleteMachineModelsMutation, useDeleteSingleModelMutation = machinesApi.useDeleteSingleModelMutation, useLazyGetMachineModelsByClientQuery = machinesApi.useLazyGetMachineModelsByClientQuery, useLazyGetAllByDocumentQuery = machinesApi.useLazyGetAllByDocumentQuery, useUpdateMachineStatusMutation = machinesApi.useUpdateMachineStatusMutation, useUpdateSerialNumberMutation = machinesApi.useUpdateSerialNumberMutation, useLazyGetByGTINQuery = machinesApi.useLazyGetByGTINQuery, useLazyGetAllMachinesByCompanyQuery = machinesApi.useLazyGetAllMachinesByCompanyQuery, useLazyGetModelNumbersByMachinesQuery = machinesApi.useLazyGetModelNumbersByMachinesQuery, useLazyGetModelsWithDocumentsQuery = machinesApi.useLazyGetModelsWithDocumentsQuery, useGetAllMachinesWithDocumentCountQuery = machinesApi.useGetAllMachinesWithDocumentCountQuery, useLazyGetModelsWithDocumentCountQuery = machinesApi.useLazyGetModelsWithDocumentCountQuery, useGetMachineAnalyticsQuery = machinesApi.useGetMachineAnalyticsQuery, useLazyGetMachineClientsSerialsQuery = machinesApi.useLazyGetMachineClientsSerialsQuery, useLazyGetModelsSerialsQuery = machinesApi.useLazyGetModelsSerialsQuery, useUpdateClientMachineMutation = machinesApi.useUpdateClientMachineMutation, useGetActiveMachinesWithModelsQuery = machinesApi.useGetActiveMachinesWithModelsQuery;
